import React from "react";
import {
	GTISnackbarProvider,
	ErrorOutline,
	DoNotDisturbAlt,
	CheckCircleOutline,
	WarningAmberRounded,
} from "@gti-controls-v2/web-core";
import snackbarStyles from "../../common/styles/snackbar";


/** Snackbar Provider que permite la modificacion de sus valores rapidamente */
export const SnackbarProvider = (props) => (
	<GTISnackbarProvider
		maxSnack={4}
		iconVariant={{
			success: <CheckCircleOutline sx={{ mr: 1 }} />,
			error: <DoNotDisturbAlt sx={{ mr: 1 }} />,
			warning: <WarningAmberRounded sx={{ mr: 1 }} />,
			info: <ErrorOutline sx={{ mr: 1 }} />,
		}}
		sx={snackbarStyles}
	>
		{props.children}
	</GTISnackbarProvider>
);
export default SnackbarProvider;
